// extracted by mini-css-extract-plugin
export default {"loadingLogo":"LoadingImg_loadingLogo__0NQA6","loading-img":"LoadingImg_loading-img__civLT","mover":"LoadingImg_mover__e-FAQ"};